import React, { createContext, useContext, useState } from 'react';

const SolicitacaoGuiasContext = createContext({});

export function useSolicitacaoGuias() {
    const context = useContext(SolicitacaoGuiasContext);
    return context;
}

export function SolicitacaoGuiasProvider({ children }) {
    const [dataSolicitacaoGuias, setDataSolicitacaoGuias] = useState({});
    const [dataContrato, setDataContrato] = useState({});
    const [dataDocuments, setDataDocuments] = useState([]);
    const [dataBeneficiario, setDataBeneficiario] = useState({});
    const [dataInputForm, setDataInputForm] = useState({});
    const [alerts, setAlerts] = useState([]);
    const [dataNumReferencia, setDataNumReferencia] = useState();

    function clearSolicitacaoGuias() {
        setDataDocuments({});
        setDataDocuments([]);
        setDataBeneficiario({});
        setDataInputForm({});
        setAlerts([]);
        setDataNumReferencia({});
    }

    return (
        <SolicitacaoGuiasContext.Provider
            value={{
                dataSolicitacaoGuias,
                setDataSolicitacaoGuias,
                dataContrato,
                setDataContrato,
                dataDocuments,
                setDataDocuments,
                clearSolicitacaoGuias,
                dataBeneficiario,
                setDataBeneficiario,
                dataInputForm,
                setDataInputForm,
                alerts,
                setAlerts,
                dataNumReferencia,
                setDataNumReferencia
            }}
        >
            {children}
        </SolicitacaoGuiasContext.Provider>
    );

}